/**
 *
 * PortalLoader
 *
 * @version 1.0.0
 * @author Vittorio
 * @since 18-Oct-2022
 */

import React from 'react';
import { Grid } from '@mui/material';
import style from './PortalLoader.scss';

const PortalLoader = () => (
  <>
    <div className={style.wrapper}>
      <div className={style.dotContainer}>
        <span className={style.dot} />
        <span className={style.dot} />
        <span className={style.dot} />
      </div>
    </div>
  </>
);

PortalLoader.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  /** Description of prop "baz". */
};

PortalLoader.defaultProps = {
  // Add here some default propTypes values
};

export default PortalLoader;
